import api from "./apiClient.js";

const endpoint = "map-icons";

export const getAllMapIcons = () => {
	return api.get(endpoint);
};
